import * as d3 from './d3';

export function computedCoordinate(treeData, baseCardSize) {
    const res = []

    const tree = d3.tree().nodeSize([
        baseCardSize.width + baseCardSize.xSpace,
        baseCardSize.height + baseCardSize.ySpace,
    ]);

    const root = d3.hierarchy(treeData);

    tree(root);

    root.descendants().forEach(node => {
        res[node.data.id] = {
            x: node['x'],
            y: node['y'] + baseCardSize.height / 2,
            depth: node.depth
        }
    })

    return res
}